import { __url } from '../absoluteUrls/absoluteUrlTranslations';

export const getSdpUrl = (printMpvId: string) => {
    return `${__url('/experts/services/details')}/${printMpvId.toLowerCase()}`;
};
